import { Injectable } from '@angular/core';
import { ApiService } from './api';

@Injectable({ providedIn: 'root' })
export class GroupsService {

    constructor(private api: ApiService) {}

    fetchGroup(groupId) {
        return this.api.get(`/ws/groups/${groupId}`);
    }

    fetchGroups(params: {page:number, rows: number, allowUsersToJoin?: boolean } = {page: 0, rows: 40, allowUsersToJoin: undefined}) {
        return this.api.get('/ws/groups/search', this.api.paramify(params));
    }

    getUserGroups(params) {
        return this.api.get('/ws/user/groups', this.api.paramify(params));
    }

    deleteGroup(groupId) {
        return this.api.delete(`/ws/groups/${groupId}`);
    }

    saveGroup(group) {
        return this.api.post('/ws/groups', group);
    }

    updateGroup(group) {
        return this.api.put('/ws/groups', group);
    }

    getUsers(params: { groupId: string, page?: number, rows?: number, sort?: string, sortDirection?: string}) {
        return this.api.get('/ws/groups/users', this.api.paramify(params));
    };

    addUser(groupId, userId) {
        return this.api.post(`/ws/groups/${groupId}/users`, [userId]);
    } 

    removeUser(groupId, userId) {
        return this.api.delete(`/ws/groups/${groupId}/users/${userId}`); 
    }

    getTopics(params) {
        return this.api.get('/ws/groups/streams', this.api.paramify(params));
    }

    addToStream(groupId: string, streamId: string, follow: boolean = true, subscribeToBriefing = false) {
        return this.api.post('/ws/groups/addToStream', this.api.paramify({ groupId, streamId, follow, subscribeToBriefing }));
    }

    removeTopic(groupId: string, streamId: string) {
        return this.api.delete('/ws/groups/deleteFromStream', { params: this.api.paramify({
            groupId: groupId,
            streamId: streamId
        })});
    }

    getBriefingSubscriptions(params: { groupId: string, page: number, rows: number }) {
        return this.api.get('/ws/groups/briefings', this.api.paramify(params));
    };

    subscribeToBriefing(groupId, briefingId, streamId?){
        return this.api.post(`/ws/groups/${groupId}/briefings/${briefingId}`, { streamId });
    };

    unsubscribeFromBriefing(groupId, briefingId){
        return this.api.delete(`/ws/groups/${groupId}/briefings/${briefingId}`);
    };
}